import { useDispatch, useSelector } from 'react-redux';
import { setToggleBBDisplay } from '@/services/table/tableActions';
import { ReducerState } from '@/services/common/lib/reducerState';

const useBBDisplay = ({ tableId }: { tableId: string }) => {
  const user = useSelector((state: ReducerState) => state.auth);

  const dispatch = useDispatch();
  const displayInBBEnabled = useSelector((state: ReducerState) => state.tables[tableId]?.displayInBBEnabled);

  const shouldDisplayInBB = displayInBBEnabled ?? user.settings?.stackInBigBlindsEnabled;

  const handleBBDisplayChange = (setting: boolean) => {
    dispatch(setToggleBBDisplay(tableId, setting));
  };

  return { displayInBBEnabled, handleBBDisplayChange, shouldDisplayInBB };
};

export default useBBDisplay;
